import React from "react";

interface ParagraphProps {
  text: string;
  tab?: number;
}

export const Paragraph = ({ text, tab }: ParagraphProps) => {
  const lines = text.split('\n');

  return (
    <div className={`text-justify mb-6 ${tab ? `pl-${tab * 4}` : ''}`}>
      {lines.map((line, index) => (
        <div className="mb-2" key={index}>
          {line}
        </div>
      ))}
    </div>
  );
}